import {createBffHooks} from '~/bff'

import type {FeatureMultiEntityRouter} from './index.bff'

export const bff = createBffHooks<FeatureMultiEntityRouter>()
